module.exports = __webpack_public_path__ + "static/media/MY.f2f675de.svg";